import React from 'react'
import LayoutContainer from './shared/LayoutContainer'
import EventList from './events/EventList'

const Events = ({ events }) => {
  return (
    <LayoutContainer>
      <h2>Termine</h2>
      <EventList eventsData={events} />
    </LayoutContainer>
  )
}

export default Events



// WEBPACK FOOTER //
// ./src/components/Events.js